
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectángulo 34","fill":"none","d":"M0 0h79v79H0z"}}),_c('g',{attrs:{"data-name":"Grupo 145","fill":"#6c757d"}},[_c('path',{attrs:{"data-name":"Trazado 54","d":"M32.36 20.787h20.254v2.893H32.36z"}}),_c('path',{attrs:{"data-name":"Trazado 55","d":"M35.253 26.574h17.36v2.893h-17.36z"}}),_c('path',{attrs:{"data-name":"Trazado 56","d":"M29.466 32.36h23.147v2.893H29.466z"}}),_c('path',{attrs:{"data-name":"Trazado 57","d":"M33.807 38.147h18.807v2.893H33.807z"}}),_c('path',{attrs:{"data-name":"Trazado 58","d":"M36.7 43.934h11.574v2.893H36.7z"}}),_c('path',{attrs:{"data-name":"Trazado 59","d":"M48.274 49.721a4.34 4.34 0 104.34 4.34 4.345 4.345 0 00-4.34-4.34zm0 5.787a1.447 1.447 0 111.447-1.447 1.448 1.448 0 01-1.447 1.447z"}}),_c('path',{attrs:{"data-name":"Trazado 60","d":"M59.848 15H32.73a9.06 9.06 0 00-9.049 9.05v17.174a5.812 5.812 0 00-2.893 9.43v4.854a5.291 5.291 0 00-5.787 5.224v3.456h43.4V26.574h5.787V19.34a4.345 4.345 0 00-4.34-4.34zM25.127 43.934a2.9 2.9 0 012.274 4.681h-4.547a2.9 2.9 0 012.273-4.681zm-1.446 7.574h2.893v4h-2.893zm8.68 9.786H17.894v-.563a2.333 2.333 0 012.331-2.331h9.805a2.333 2.333 0 012.331 2.331v.563zM55.508 19.34v41.955H35.254a5.313 5.313 0 00-5.787-5.787v-4.854a5.812 5.812 0 00-2.893-9.43V24.05a6.163 6.163 0 016.156-6.156h23.027a4.318 4.318 0 00-.249 1.447zm5.787 4.34h-2.894v-4.34a1.447 1.447 0 112.893 0z"}})])])
          )
        }
      }
    